import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f21736"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-page__form-inner-container checkout-page__inner-container" }
const _hoisted_2 = { class: "checkout-page__form-header-container" }
const _hoisted_3 = { class: "checkout-page__form-header" }
const _hoisted_4 = {
  key: 0,
  class: "checkout-page__select-addresses"
}
const _hoisted_5 = { class: "checkout-page__input-group" }
const _hoisted_6 = { class: "checkout-page__discount-code" }
const _hoisted_7 = { class: "checkbox-input-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-input-mark" }, null, -1))
const _hoisted_9 = { class: "checkout-page__input-group" }
const _hoisted_10 = {
  key: 4,
  class: "text-input__error-message text-input__error-message--global"
}
const _hoisted_11 = { class: "checkout-page__form-button-container" }
const _hoisted_12 = ["disabled"]

import { ICustomerAddress } from "@/models/ICustomerAddress";
import { UpdateCustomerCommand } from "@/models/Checkout";
import { CheckoutApi } from "@/services/Api";
import { PropType, computed, onMounted, ref } from "vue";
import dictionary from "@/i18n/dictionary.json";
import TressTextInput from "@/components/TressTextInput.vue";
import TressCheckoutAddressViewer from "@/components/TressCheckoutAddressViewer.vue";
import TressCheckoutManualAddressOption from "@/components/TressCheckoutManualAddressOption.vue";
import TressCheckoutAddressOption from "@/components/TressCheckoutAddressOption.vue";
import { CustomerType } from "@/enums/CustomerType";
import TressCheckoutAddressViewerDouble from "@/components/TressCheckoutAddressViewerDouble.vue";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import { ICheckoutAddresses } from "@/models/ICheckoutAddresses";
import { useCheckout } from "@/store/useCheckout";
import TressDropdown from "@/components/TressDropdown.vue";
import { RegisterAccountType } from "@/models/AccountRegister";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutCustomerDataForm',
  props: {
  addresses: {
    type: Object as PropType<ICheckoutAddresses>,
    required: true,
  },
  openAccordionId: {
    type: String,
    required: true,
  },
  openAccordionHeight: {
    type: [String, Number],
    required: true,
  },
  isLoggedIn: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: {
  submit: () => {
    return true;
  },
  edit: () => {
    return true;
  },
  preSubmit: () => {
    return true;
  },
  submitFail: () => {
    return true;
  },
},
  setup(__props, { emit }) {

const props = __props;

const checkout = useCheckout();
const vuewindow = window;
if (checkout.customerType != window.customerType) {
  checkout.reset();
  checkout.setCustomerType(window.customerType);
}
const t = useI18n().t;


const isSending = ref<boolean>(false);
const currentAddress = ref<ICustomerAddress>();
const shippingAddress = ref<ICustomerAddress>();
const addresses = ref<ICheckoutAddresses>(props.addresses);
const hasAnotherAddress = ref<boolean>(false);
const model = ref<any>({});
const zipCodeRules = ref<RegExp>(/^[0-9]{4,5}$/);
const customerType = ref<string>(window.customerType);
const manualAddressOptionAvailable = computed(() => {
  return props.isLoggedIn && props.addresses.standardAddress;
});

const lang = (document.querySelector("html") as HTMLHtmlElement).getAttribute("lang") as string;

const userSelectorItems: { key: RegisterAccountType; value: string }[] = [
  { key: "private", value: t(dictionary.common.private) },
  { key: "business", value: t(dictionary.common.business) },
];
const selectedForm = ref(CustomerType.Private == window.customerType ? CustomerType.Private : CustomerType.Business);
const culture = (document.querySelector("div[data-culture]") as HTMLHtmlElement).getAttribute("data-culture") as string;
const onCustomerDataFormSubmit = async (values) => {
  try {
    emit("preSubmit");
    isSending.value = true;
    if (showCustomerDataForm.value) {
      currentAddress.value = {
        zipcode: values.zipcode,
        selected: true,
        phoneNumber: values.phoneNumber,
        fullName: values.fullName,
        address: values.address,
        address2: values.address2,
        city: values.city,
        ean: values.ean,
        attention: values.attention,
        email: values.email,
        organizationNumber: values.organizationNumber,
        reference: values.reference,
      };
    }
    if (values.shippingFullName) {
      shippingAddress.value = {
        zipcode: values.shippingZipCode,
        selected: true,
        phoneNumber: values.shippingPhoneNumber,
        fullName: values.shippingFullName,
        address: values.shippingAddress,
        address2: values.shippingAddress2,
        city: values.shippingCity,
        ean: values.shippingEan,
        attention: values.shippingAttention,
        email: values.shippingEmail,
        organizationNumber: values.shippingOrganizationNumber,
        reference: values.shippingReference,
      };
    } else {
      shippingAddress.value = undefined;
    }
    const cmd: UpdateCustomerCommand = {
      payingAddress: currentAddress.value!,
      shippingAddress: shippingAddress.value,
    };
    await CheckoutApi.updateCustomer(cmd);
    await checkout.setShippingPostalCode(currentPostalCode.value);
    emit("submit");
  } catch (e: any) {
    emit("submitFail");
    await Swal.fire<void>({
      icon: "error",
      text: t(dictionary.checkout.updateCustomerError),
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "btn btn-success button button--default",
      },
      buttonsStyling: false,
    });
  } finally {
    isSending.value = false;
  }
};
const _setZipCodeRules = () => {
  if (lang == "sv") {
    zipCodeRules.value = /^[0-9]{5}$/;
  }
};
const _resetSelectedAddresses = () => {
  if (addresses.value.standardAddress) {
    addresses.value.standardAddress.selected = false;
  }
  if (addresses.value.alternateAddress) {
    addresses.value.alternateAddress.selected = false;
  }
  if (addresses.value.manualAddress) {
    addresses.value.manualAddress.selected = false;
  }
};
const _setInitialSelectedAddress = () => {
  let newModel = {};
  if (
    !addresses.value.standardAddress?.selected &&
    !addresses.value.alternateAddress?.selected &&
    !addresses.value.manualAddress?.selected
  ) {
    if (addresses.value.standardAddress) {
      addresses.value.standardAddress.selected = true;
      currentAddress.value = addresses.value.standardAddress;
    } else if (addresses.value.alternateAddress) {
      addresses.value.alternateAddress.selected = true;
      currentAddress.value = addresses.value.alternateAddress;
    } else if (addresses.value.manualAddress) {
      showCustomerDataForm.value = true;
      addresses.value.manualAddress.selected = true;
      currentAddress.value = addresses.value.manualAddress;
    }
  }
  if (addresses.value.standardAddress?.selected) {
    currentAddress.value = addresses.value.standardAddress;
  } else if (addresses.value.alternateAddress?.selected) {
    currentAddress.value = addresses.value.alternateAddress;
  } else if (addresses.value.manualAddress?.selected) {
    showCustomerDataForm.value = true;
    currentAddress.value = addresses.value.manualAddress;
    newModel = { ...addresses.value.manualAddress };
  }

  if (addresses.value.shippingAddress) {
    newModel = {
      ...newModel,
      shippingFullName: addresses.value.shippingAddress.fullName,
      shippingAttention: addresses.value.shippingAddress.attention,
      shippingOrganizationNumber: addresses.value.shippingAddress.organizationNumber,
      shippingEan: addresses.value.shippingAddress.ean,
      shippingAddress: addresses.value.shippingAddress.address,
      shippingAddress2: addresses.value.shippingAddress.address2,
      shippingZipcode: addresses.value.shippingAddress.zipcode,
      shippingCity: addresses.value.shippingAddress.city,
      shippingEmail: addresses.value.shippingAddress.email,
      shippingPhoneNumber: addresses.value.shippingAddress.phoneNumber,
      shippingReference: addresses.value.shippingAddress.reference,
    };
    setTimeout(() => {
      hasAnotherAddress.value = true;
    }, 300);
  }
  model.value = { ...newModel };
};

const _setInitialPostalCode = async () => {
  if (currentPostalCode.value) {
    await checkout.setShippingPostalCode(currentPostalCode.value);
  }
};

onMounted(() => {
  _setInitialSelectedAddress();
  _setZipCodeRules();
  _setInitialPostalCode();
});

const showCustomerDataForm = ref<boolean>(false);
const onAddressOptionClick = (address: ICustomerAddress) => {
  _resetSelectedAddresses();
  address.selected = true;
  currentAddress.value = address;
  showCustomerDataForm.value = false;
};
const onManualAddressOptionClick = () => {
  _resetSelectedAddresses();
  showCustomerDataForm.value = true;
};

const currentPostalCode = computed(() => {
  return model.value.shippingZipcode ?? currentAddress.value?.zipcode ?? "";
});

const onChangeStep = () => {
  emit("edit");
};

return (_ctx: any,_cache: any) => {
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    class: "checkout-page__form",
    onSubmit: onCustomerDataFormSubmit
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.step1)), 1),
          (__props.openAccordionId !== 'step1')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "checkout-page__form-button-change",
                onClick: onChangeStep,
                type: "button"
              }, _toDisplayString(_ctx.$t(_unref(dictionary).common.change)), 1))
            : _createCommentVNode("", true)
        ]),
        (__props.openAccordionId != 'step1' && !shippingAddress.value)
          ? (_openBlock(), _createBlock(TressCheckoutAddressViewer, {
              key: 0,
              address: currentAddress.value
            }, null, 8, ["address"]))
          : _createCommentVNode("", true),
        (__props.openAccordionId != 'step1' && shippingAddress.value)
          ? (_openBlock(), _createBlock(TressCheckoutAddressViewerDouble, {
              key: 1,
              address2: shippingAddress.value,
              address: currentAddress.value
            }, null, 8, ["address2", "address"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          style: _normalizeStyle({ height: __props.openAccordionId == 'step1' ? __props.openAccordionHeight : 0 }),
          class: "checkout-page__form-inner-inner-container"
        }, [
          _createVNode(TressDropdown, {
            items: userSelectorItems,
            selected: selectedForm.value,
            class: "sign-in__form-type-dropdown",
            "onUpdate:selected": _cache[0] || (_cache[0] = 
            (e) =>
              (_unref(vuewindow).location.href = `/umbraco/surface/customer/Switch?type=${e}&culture=${_unref(culture)}&redirectUrl=${encodeURIComponent(
                _unref(vuewindow).location.pathname
              )}`)
          )
          }, null, 8, ["selected"]),
          (addresses.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (addresses.value.standardAddress)
                  ? (_openBlock(), _createBlock(TressCheckoutAddressOption, {
                      key: 0,
                      address: addresses.value.standardAddress,
                      onClick: onAddressOptionClick
                    }, null, 8, ["address"]))
                  : _createCommentVNode("", true),
                (addresses.value.alternateAddress)
                  ? (_openBlock(), _createBlock(TressCheckoutAddressOption, {
                      key: 1,
                      address: addresses.value.alternateAddress,
                      onClick: onAddressOptionClick
                    }, null, 8, ["address"]))
                  : _createCommentVNode("", true),
                (manualAddressOptionAvailable.value)
                  ? (_openBlock(), _createBlock(TressCheckoutManualAddressOption, {
                      key: 2,
                      onClick: onManualAddressOptionClick
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!showCustomerDataForm.value)
            ? (_openBlock(), _createBlock(TressCheckoutAddressViewer, {
                key: 1,
                address: currentAddress.value
              }, null, 8, ["address"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(TressTextInput, {
                  modelValue: model.value.fullName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.fullName) = $event)),
                  label: 
              customerType.value == _unref(CustomerType).Business
                ? _ctx.$t(_unref(dictionary).form.companyName.label)
                : _ctx.$t(_unref(dictionary).form.fullName.label)
            ,
                  class: "checkout-page__input",
                  name: "fullName",
                  rules: "required"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customerType.value == _unref(CustomerType).Business
                  ? _ctx.$t(_unref(dictionary).form.companyName.label)
                  : _ctx.$t(_unref(dictionary).form.fullName.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                (customerType.value == _unref(CustomerType).Business)
                  ? (_openBlock(), _createBlock(TressTextInput, {
                      key: 0,
                      modelValue: model.value.attention,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.attention) = $event)),
                      label: _ctx.$t(_unref(dictionary).form.attention.label),
                      class: "checkout-page__input",
                      name: "attention"
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.attention.label)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true),
                (customerType.value == _unref(CustomerType).Business)
                  ? (_openBlock(), _createBlock(TressTextInput, {
                      key: 1,
                      modelValue: model.value.organizationNumber,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.organizationNumber) = $event)),
                      label: _ctx.$t(_unref(dictionary).form.orgNo.label),
                      class: "checkout-page__input",
                      name: "organizationNumber"
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.orgNo.label)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true),
                (customerType.value == _unref(CustomerType).Business && _unref(lang) == 'da')
                  ? (_openBlock(), _createBlock(TressTextInput, {
                      key: 2,
                      modelValue: model.value.ean,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.value.ean) = $event)),
                      label: _ctx.$t(_unref(dictionary).form.ean.label),
                      class: "checkout-page__input",
                      name: "ean",
                      maxlength: 13
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.ean.label)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true),
                _createVNode(TressTextInput, {
                  modelValue: model.value.address,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model.value.address) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.address.label),
                  class: "checkout-page__input",
                  name: "address",
                  rules: "required"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.address.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.address2,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((model.value.address2) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.address2.label),
                  class: "checkout-page__input",
                  name: "address2"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.address2.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(TressTextInput, {
                    modelValue: model.value.zipcode,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((model.value.zipcode) = $event)),
                    label: _ctx.$t(_unref(dictionary).form.zipCode.label),
                    rules: { required: true, regex: zipCodeRules.value },
                    class: "checkout-page__input checkout-page__input--two",
                    name: "zipcode"
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.zipCode.label)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "rules"]),
                  _createVNode(TressTextInput, {
                    modelValue: model.value.city,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((model.value.city) = $event)),
                    label: _ctx.$t(_unref(dictionary).form.city.label),
                    class: "checkout-page__input checkout-page__input--two",
                    name: "city",
                    rules: "required"
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.city.label)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"])
                ]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((model.value.email) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.email.label),
                  class: "checkout-page__input",
                  name: "email",
                  rules: "required|email"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.email.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.phoneNumber,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((model.value.phoneNumber) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.phoneNumber.label),
                  class: "checkout-page__input",
                  name: "phoneNumber",
                  rules: { required: true, regex: /^\d*$/ }
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.phoneNumber.placeholder)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                (customerType.value == _unref(CustomerType).Business)
                  ? (_openBlock(), _createBlock(TressTextInput, {
                      key: 3,
                      modelValue: model.value.reference,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((model.value.reference) = $event)),
                      label: _ctx.$t(_unref(dictionary).form.referenceNumber.label),
                      class: "checkout-page__input",
                      name: "reference",
                      maxlength: 50
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.referenceNumber.label)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("label", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((hasAnotherAddress).value = $event)),
                class: "checkbox-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, hasAnotherAddress.value]
              ]),
              _hoisted_8
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(_unref(dictionary).checkout.deliverToAnotherAddress)), 1)
          ]),
          (hasAnotherAddress.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(TressTextInput, {
                  modelValue: model.value.shippingFullName,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((model.value.shippingFullName) = $event)),
                  label: 
              customerType.value == _unref(CustomerType).Business
                ? _ctx.$t(_unref(dictionary).form.companyName.label)
                : _ctx.$t(_unref(dictionary).form.fullName.label)
            ,
                  class: "checkout-page__input",
                  name: "shippingFullName",
                  rules: "required"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customerType.value == _unref(CustomerType).Business
                  ? _ctx.$t(_unref(dictionary).form.companyName.label)
                  : _ctx.$t(_unref(dictionary).form.fullName.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.shippingAttention,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((model.value.shippingAttention) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.attention.label),
                  class: "checkout-page__input",
                  name: "shippingAttention"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.attention.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.shippingAddress,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((model.value.shippingAddress) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.address.label),
                  class: "checkout-page__input",
                  name: "shippingAddress",
                  rules: "required"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.address.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.shippingAddress2,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((model.value.shippingAddress2) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.address2.label),
                  class: "checkout-page__input",
                  name: "shippingAddress2"
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.address2.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(TressTextInput, {
                    modelValue: model.value.shippingZipcode,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((model.value.shippingZipcode) = $event)),
                    label: _ctx.$t(_unref(dictionary).form.zipCode.label),
                    rules: { required: true, regex: zipCodeRules.value },
                    class: "checkout-page__input checkout-page__input--two",
                    name: "shippingZipCode"
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.zipCode.label)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "rules"]),
                  _createVNode(TressTextInput, {
                    modelValue: model.value.shippingCity,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((model.value.shippingCity) = $event)),
                    label: _ctx.$t(_unref(dictionary).form.city.label),
                    class: "checkout-page__input checkout-page__input--two",
                    name: "shippingCity",
                    rules: "required"
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.city.label)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"])
                ]),
                _createVNode(TressTextInput, {
                  modelValue: model.value.shippingPhoneNumber,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((model.value.shippingPhoneNumber) = $event)),
                  label: _ctx.$t(_unref(dictionary).form.phoneNumber.label),
                  class: "checkout-page__input",
                  name: "shippingPhoneNumber",
                  rules: { required: true, regex: /^\d*$/ }
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).form.phoneNumber.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "label"])
              ], 64))
            : _createCommentVNode("", true),
          (Object.keys(errors).length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.customerDataFormGlobalError)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "submit",
              class: "checkout-page__form-button",
              disabled: isSending.value
            }, _toDisplayString(_ctx.$t(_unref(dictionary).common.continue)), 9, _hoisted_12)
          ])
        ], 4), [
          [_vShow, __props.openAccordionId == 'step1']
        ])
      ])
    ]),
    _: 1
  }))
}
}

})